import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useSupplierModel } from "../supplierModel";
export function PageHeader() {
    const { t } = useTranslation();
    const { searchParam, loadData, updateSearchParam, resetSearchParam } = useSupplierModel()
    const searchFields = [
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.供应商编码`),
            fieldName: "code",
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.供应商名称`),
            fieldName: "name",
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.联系人`),
            fieldName: "contact",
        },
        {
            type: "Input",
            placeholder: t(`base.view.PageHeader.联系电话`),
            fieldName: "phone",
        },
        {
            type: "Select",
            placeholder: t(`base.view.PageHeader.供应商状态`),
            fieldName: "enable",
            options: [
                { label: t(`base.view.PageHeader.启用`), value: 1 },
                { label: t(`base.view.PageHeader.禁用`), value: 0 },
            ],
        }
    ]

    return (
        <YhPageHeader
            title= {t(`base.view.PageHeader.供应商档案`)}
            size="small"
            triggerSearch={true}
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    )
}
